var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "label-modal",
    attrs: {
      title: (_vm.isEdit ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("标签"),
      visible: _vm.visible,
      width: 600
    },
    on: {
      cancel: e => _vm.closeAddVisible(e)
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标签名称"),
      prop: "tagsName"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.tagsName,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "tagsName", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.tagsName"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.saveLoading,
      disabled: _vm.saveLoading
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.saveLoading ? "" : _vm.$t("保存")) + " ")])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };